import * as React from 'react';
import { SVGProps } from 'react';

const IconNodeStepSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 2h8v1.55a2.512 2.512 0 0 1 1 0V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v1.55a2.512 2.512 0 0 1 1 0V2zm0 6.45a2.512 2.512 0 0 1-1 0V10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8.45a2.512 2.512 0 0 1-1 0V10H2V8.45zM12 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM1.5 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
  </svg>
);
export default IconNodeStepSizeXs;
